import { DotLogo } from "@/components/marketing/dot-logo";

/**
 * The brand wordmark: the dot-matrix "TUTORIALS" logo over the "a part of
 * Coaley Peak®" line. `small` swaps the animated dot-matrix for a static serif wordmark
 * for tight spaces (e.g. the mobile menu overlay). Shared by the marketing
 * header and the dashboard so the logo is identical everywhere.
 */
export function Wordmark({ small = false }: { small?: boolean }) {
  return (
    <span className="flex flex-col">
      {small ? (
        <span className="font-heading text-lg font-semibold uppercase leading-none tracking-[0.04em] text-dark">
          Tutorials
        </span>
      ) : (
        <>
          <DotLogo text="Tutorials" size={28} />
          <span className="sr-only">Tutorials</span>
        </>
      )}
      <span className="mt-0.5 flex items-center gap-1 text-[10px] leading-tight text-mid">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="/images/coaley-peak-icon.svg"
          alt=""
          width={12}
          height={12}
          className="rounded-sm"
          aria-hidden="true"
        />
        A part of Coaley Peak<sup>&reg;</sup>
      </span>
    </span>
  );
}
